module.exports = __webpack_public_path__ + "static/img/mss-1.5282d6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mss/mss-1.png
// module id = UVE2
// module chunks = 1